(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // scroll reveal
  if ('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
    }, {threshold:0.1, rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }
  // count-up
  function animateCount(el){
    var target = parseInt(el.dataset.count,10); if(!target) return;
    if(reduce){ el.textContent='$'+target.toLocaleString()+'+'; return; }
    var dur=1700, start=null;
    function step(ts){ if(!start)start=ts; var p=Math.min((ts-start)/dur,1);
      var v=Math.floor((1-Math.pow(1-p,3))*target);
      el.textContent='$'+v.toLocaleString()+'+';
      if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window){
    var co = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ animateCount(e.target); co.unobserve(e.target);}});
    },{threshold:0.6});
    document.querySelectorAll('[data-count]').forEach(function(el){ co.observe(el); });
  }
})();

// hide broken images (graceful fallback to dark card bg)
(function(){
  function hide(im){ im.style.display='none'; }
  document.querySelectorAll('img').forEach(function(im){
    if(im.complete && im.naturalWidth===0 && im.src){ hide(im); }
    im.addEventListener('error',function(){ hide(im); });
  });
})();
